"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageAVAsset = void 0;
const SuperprepAsset_1 = require("./SuperprepAsset");
// import { SuperprepAssetUtil } from "./SuperprepAssetUtil";
class LanguageAVAsset extends SuperprepAsset_1.SuperprepAsset {
    constructor(fileName, assetType, text, languageType, isSentence, translation) {
        super(fileName, assetType);
        this.duration = 0;
        this.languageType = languageType;
        this.isSentence = isSentence;
        this.text = text;
        this.translation = translation;
    }
    static fromAlgolia(documentData) {
        const id = documentData.objectID;
        const text = documentData.text;
        const fileName = documentData.fileName;
        const tags = documentData.tags;
        const assetType = documentData.assetType;
        const languageType = documentData.languageType;
        const duration = documentData.duration;
        const isSentence = documentData.isSentence;
        const translation = documentData.translation;
        const data = new LanguageAVAsset(fileName, assetType, text, languageType, isSentence, translation);
        data.duration = duration;
        data.tags = tags;
        data.id = id;
        return data;
    }
    getConverter() {
        return LanguageAVAsset.converter;
    }
}
exports.LanguageAVAsset = LanguageAVAsset;
LanguageAVAsset.converter = {
    toFirestore(data) {
        const parent = SuperprepAsset_1.SuperprepAsset.converter.toFirestore(data);
        let child = {};
        if (data instanceof LanguageAVAsset) {
            child = {
                languageType: data.languageType,
                duration: data.duration,
                isSentence: data.isSentence,
                text: data.text,
                translation: data.translation
            };
        }
        return Object.assign(Object.assign({}, parent), child);
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const text = documentData.text;
        const fileName = documentData.fileName;
        const tags = documentData.tags;
        const assetType = documentData.assetType;
        const languageType = documentData.languageType;
        const duration = documentData.duration;
        const isSentence = documentData.isSentence;
        const translation = documentData.translation;
        const data = new LanguageAVAsset(fileName, assetType, text, languageType, isSentence, translation);
        data.duration = duration;
        data.tags = tags;
        data.id = id;
        return data;
    }
};
// async function listAssets(db: Firestore): Promise<SuperprepAsset[]> {
//   const colRef = collection(db, "colPath");
//   const snapshot = await getDocs(colRef);
//   const assets: SuperprepAsset[] = [];
//   snapshot.forEach((snap) => {
//     const base = SuperprepAsset.converter.fromFirestore(snap);
//     const converter = SuperprepAssetUtil.getConverter(base.assetType);
//     assets.push(converter.fromFirestore(snap));
//   });
//   return assets;
// }
// async function getAsset(db: Firestore): Promise<SuperprepAsset | undefined> {
//   const docRef = doc(db, "colPath", "docId");
//   const snapshot = await getDoc(docRef);
//   if (!snapshot.exists) {
//     return undefined;
//   }
//   const base = SuperprepAsset.converter.fromFirestore(snapshot as QueryDocumentSnapshot);
//   const converter = SuperprepAssetUtil.getConverter(base.assetType);
//   return converter.fromFirestore(snapshot as QueryDocumentSnapshot);
// }
// async function setAsset(db: Firestore) {
//   const asset = new LanguageAVAsset(
//     "123", AssetType.Audio, { english: "123" }, LanguageType.English, false, undefined);
//   const docRef = doc(db, "colPath", "docId").withConverter(asset.getConverter());
//   await setDoc(docRef, asset);
// }
